var config = {
    // host: 'http://localhost/manage/api',
    // webImg: 'http://localhost/manage'
    // host:'http://web.guotone.com/manage/api',
    // webImg:'http://web.guotone.com/manage'
    // host:'http://guojigw.hefeiapp.cn/manage/api',
    // webImg:'http://guojigw.hefeiapp.cn/manage'

}
let port = ""
if ('116.62.66.74' == location.hostname) {
    port = ":9208"
}
// config.host = location.protocol + '//' + '192.168.3.3:9208'  + '/manage/api'
// config.webImg = 'http://192.168.3.3:9208' + '/manage'
config.host = 'https://www.waterjet.com.cn/' + '/manage/api'
config.webImg ='https://www.waterjet.com.cn/' + '/manage'
console.log(config);
export default config




// WEBPACK FOOTER //
// ./src/utils/config.js